import { Role } from '@guiker/permissions'

import { LeaseRoleNames } from '../../entity'
import { LeaseActions } from '../lease-actions'

export const DrafterRole: Role = {
  name: LeaseRoleNames.DRAFTER,
  permissions: [{ action: LeaseActions.DraftLease }, { action: LeaseActions.ViewLease }],
}
